import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-confirm-deletion',
  standalone: true,
  imports: [],
  templateUrl: './confirm-deletion.component.html',
  styleUrl: './confirm-deletion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDeletionComponent implements OnInit {
  constructor(private route: ActivatedRoute, private authService: AuthService, private router: Router) {}

  ngOnInit() {
    const token = this.route.snapshot.queryParams['token'];
    this.authService
      .deleteAccount(token)
      .pipe(take(1))
      .subscribe((success: boolean) => {
        if (!success) {
          alert('Account deletion failed');
          window.location.href = this.authService.redirectUrl;
          return;
        }
        this.authService.init();
        window.location.href = this.authService.redirectUrl;
      });
  }
}
